<template>
  <div>
    <b-card class="rounded-xl border-none">
      <modal
        :show.sync="tableModal"
        header-classes="bg-primary p-3"
        class="modal-lg"
        size="lg"
      >
        <h6 slot="header" class="modal-title text-white font-semibold pt-1">
          Scope
        </h6>
        <VendorTable :selectedName="selectedName" />
      </modal>
      <AddTagsSidebar
        :isSidebarActive="openAddBannerSidebar"
        @closeSidebar="toggleAddBannerSidebar"
      />
      <div class="flex  justify-between  items-center">
        <div>
          <h2 class="text-2xl font-semibold">
            Scope
          </h2>
          <!-- 
        <small class=" text-muted "
          >Lorem ipsum dolor sit amet, consectetur adipiscing elit,
        </small> -->
        </div>
        <div class="flex ">
          <base-button
            filled
            type="primary"
            class="flex px-3 py-1"
            @click="addBanner"
          >
            <feather-icon icon="PlusIcon" class="mr-1"></feather-icon>New Custom
            Features
          </base-button>
          <base-button
            filled
            type="primary"
            class="flex px-3 py-1"
            @click="addBanner"
          >
            <feather-icon icon="PlusIcon" class="mr-1"></feather-icon>Add
            Version
          </base-button>
        </div>
      </div>

      <div class="one-case mt-8">
        <div class="step-indicator">
          <li class="complete">
            <div class="step">
              <i class="fa fa-check-circle"></i>
            </div>
            <div class="caption hidden-xs hidden-sm">
              Analysis
            </div>
          </li>
          <li class="complete">
            <div class="step">
              <i class="fa fa-check-circle"></i>
            </div>
            <div class="caption hidden-xs hidden-sm">
              Development
            </div>
          </li>
          <li class="">
            <div class="step">
              <i class="fa fa-check-circle"></i>
              <!--        <i class="fa fa-times-circle"></i>-->
            </div>
            <div class="caption hidden-xs hidden-sm">
              Deployment
            </div>
          </li>
        </div>
      </div>
      <b-card no-body class="mt-2">
        <b-tabs card>
          <b-tab
            title="Version 1"
            active
            class="px-2 "
            title-item-class=" px-2"
          >
            <el-table
              class="table-responsive table-flush mt-6 cust-overflow-x-primary-color cust-bg-striped"
              header-row-class-name="thead-light table-th-colorblue"
              :data="TagsData"
            >
              <el-table-column
                label="Pages"
                min-width="150px"
                prop="pages"
                sortable
              >
                <template v-slot="{ row }">
                  <span class=" text-black font-normal">{{ row.pages }}</span>
                </template>
              </el-table-column>

              <el-table-column
                label="Feature Name"
                min-width="150px"
                prop="featurename"
                sortable
              >
                <template v-slot="{ row }">
                  <span class=" text-black font-normal">{{
                    row.featurename
                  }}</span>
                </template>
              </el-table-column>

              <el-table-column
                label="Type"
                min-width="130px"
                prop="type"
                sortable
              >
                <template v-slot="{ row }">
                  <span class=" text-black font-normal">{{ row.type }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="Suite Extension"
                min-width="180px"
                prop="extension"
                sortable
              >
                <template v-slot="{ row }">
                  <span class=" text-black font-normal">{{
                    row.extension
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="Notes"
                min-width="250px"
                prop="notes"
                sortable
              >
                <template v-slot="{ row }">
                  <span class=" text-black font-normal">{{ row.notes }}</span>
                </template>
              </el-table-column>

              <!-- <el-table-column
                label="Active"
                min-width="100px"
                prop="active"
                sortable
              >
                <template>
                  <div class="flex items-center ml-4">
                    <div
                      class="flex items-center cursor-pointer"
                      data-toggle="tooltip"
                      data-placement="top"
                      title="Edit"
                    >
                      <label class="custom-toggle mb-0">
                        <input type="checkbox" checked />
                        <span
                          class="custom-toggle-slider rounded-circle"
                          data-label-off="Yes"
                          data-label-on="No"
                        ></span>
                      </label>
                    </div>
                  </div>
                </template>
              </el-table-column> -->

              <el-table-column label="Action" min-width="100px">
                <template v-slot="{ row }">
                  <div class="flex items-center ml-4">
                    <div
                      class="flex items-center cursor-pointer"
                      data-toggle="tooltip"
                      data-placement="top"
                      title="Edit"
                    >
                      <feather-icon
                        icon="EditIcon"
                        svgClasses="w-5"
                        @click="
                          tableModal = true;
                          selectedName = row.vendorname;
                        "
                        block
                      ></feather-icon>
                    </div>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </b-tab>
          <b-tab
            title="Version 1"
            active
            class="px-2 "
            title-item-class=" px-2"
          >
            <b-card-text>Table contents 2</b-card-text>
          </b-tab>
          <b-tab
            title="Version 1"
            active
            class="px-2 "
            title-item-class=" px-2"
          >
            <b-card-text>Table contents 3</b-card-text>
          </b-tab>
        </b-tabs>
      </b-card>

      <b-card-footer class="py-4 d-flex justify-content-end">
        <base-pagination
          v-model="currentPage"
          :per-page="10"
          :total="50"
        ></base-pagination>
      </b-card-footer>
    </b-card>
  </div>
</template>
<script>
import "@/views/admin/scss/Index.scss";
import TagsData from "./../components/TagsData";
import VendorTable from "./../components/VendorTable";
import AddTagsSidebar from "./../components/AddTagsSidebar";
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown
} from "element-ui";
export default {
  name: "light-table",
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    AddTagsSidebar,
    VendorTable
  },
  data() {
    return {
      TagsData,
      currentPage: 1,
      // editModal: false,
      tableModal: false,
      openAddBannerSidebar: false,
      selectedName: ""
    };
  },
  methods: {
    addBanner() {
      this.toggleAddBannerSidebar(true);
    },
    toggleAddBannerSidebar(val = false) {
      this.openAddBannerSidebar = val;
    }
  }
};
</script>
<style>
.table-th-colorblue th {
  padding: 5px 0px !important;
  background-color: #830c81 !important;
  color: #fff !important;
}
/* .cust-bg-striped
  > .el-table__body-wrapper
  .is-scrolling-none
  > .el-table__body
  > tbody
  > .el-table__row
  .el-table__row--striped {
  background-color: aquamarine;
} */
.el-table--striped .el-table__body tr.el-table__row--striped td {
  background: #f4e9f4;
}
</style>
